import { createContext } from 'react';
import { IStrategyPageContext, IStrategyPagePayload, StrategyPageType } from '../interface';

export default createContext<IStrategyPageContext & {
  /** dispatch */
  dispatch: (type: StrategyPageType, payload: IStrategyPagePayload) => void;
}>({
  ruleFormItems: [],
  actionFormItems: [],
  optionalFormItems: [],
  contentFormItems: [],
  dispatch: () => {},
});
